// extracted by mini-css-extract-plugin
export var currencyInput = "_kj-1";
export var currencySymbol = "_kj-0";